import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    ie:{
      translations: require('./locales/ie/translations.json')
    },
    es: {
      translations: require('./locales/es/translations.json')
    },
    ro: {
        translations: require('./locales/ro/translations.json')
      }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'ie','es','ro'];

export default i18n;